import { StyleProps, CSS } from "@shared/primitive-components"

export const policyInfoWrapper = (props: StyleProps) => ({
  fontSize: props.theme.fontSize.caption,
  padding: props.theme.spacing(3, 3, 0, 6),
  color: props.theme.palette.white,
  marginBottom: props.theme.spacing(2),
  "& p": {
    marginBottom: props.theme.spacing(2),
  },
  "@media (max-width: 600px)": {
    marginBottom: `5rem`,
  },
})

export const decreaseSpacing = (finalElement: boolean) => (props: StyleProps) => ({
  marginBottom: finalElement ? props.theme.spacing(2) : props.theme.spacing(0),
})

export const addTSPLink = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(2),
  color: props.theme.palette.link,
  cursor: `pointer`,
})

export const blurWhite = (): CSS => ({
  color: `transparent`,
  textShadow: `1px 1px 8px white`,
})
